import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './CommonHelpCenter.css';
import Footer from "../../Footer";
import Accordion from 'react-bootstrap/Accordion';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import Topbar from "../../Topbar";

const CommonHelpCenter = () => {
    const [loading,setLoading] = useState(true);
    const [help, setHelp] = useState([]);

    useEffect(() => {
        document.title = `Contact Us | Local Bells`;
        document.getElementById('bodywrap').className = 'comhelp';

        /* Start get help */
            API.post('get_faq')
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                  setHelp(response.data.data);
                }                  
            }).catch(error => {
                setLoading(false); 
            });  
        /* End get help */

    }, []);


    return (
        <>
            <Topbar />
            <section className="main-cont-box">
                <Container>
                    <Row>
                        {/*<NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />*/}
                        <Col md={12} lg={12} xl={12} xxl={12} className='main-cont-box-right'>
                            {/*<Header toggleSidebar={toggleSidebar} />*/}
                            <div className='nei-cont'>
                                <div className='white-box acc-box'>
                                    <Row>
                                        <Col xs={12}>
                                            <h3>General Questions</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <Accordion defaultActiveKey="0">
                                               {help && help.map((val, index) => {
                                                    return (
                                                        <Accordion.Item eventKey={index.toString()} key={index}>
                                                            <Accordion.Header>{val.title}</Accordion.Header>
                                                            <Accordion.Body>
                                                                {val.description}
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                    );
                                                })}
                                                
                                            </Accordion>
                                        </Col>
                                    </Row>
                                </div>
                                                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Footer />
             {loading && (
               <div className="loadingClass">
                <img src={loader} alt="loader"/>
              </div>
               )}  
        </>
    )
}

export default CommonHelpCenter;